
LenderOnboarding.prototype.observers = function(){
  var _this = this;

  var observers = [
    this.$firstname,
    this.$lastname,
    this.$email,
    this.$password,
    this.$yes,
    this.$no,
    this.$referredBy,
    this.$agreements,
    this.$regulations
  ];

  observers.forEach(function(observer) {
    //manage steps validation
    observer.on('blur input change click',
      debounce(_this.validation.bind(_this), 400)
    );
    observer.on('blur input change click', function(){
      $('fieldset.active input').removeClass('callback');
      if($(this).parents('fieldset').hasClass('checked')){
        $(this).removeClass('error');
        $(this).parents('fieldset').find('.errors').fadeOut('fast');
        $('.error').fadeOut('fast');
      }
    });
    //manage inputs validation
    observer.on('input focus', function(){
      if($(this).parents('fieldset').attr('id') === 'name'){
        $(this).parents('fieldset').find('input').removeClass('error valid');
      }else{
        $(this).removeClass('error valid');
      }
    });
    //manage done & edit statuses
    observer.on('focus click', function(){
      if($(this).parents('fieldset').hasClass('done')){
        $(this).parents('fieldset').addClass('edit');
        $(this).addClass('callback');
      }
      setTimeout(function(){
        _this.fadePreviousSteps(observer);
        _this.fadeNextSteps(observer);
      }, 450);
      $(this).parents('fieldset').smoothScrollTop();
    });
    observer.on('input', function(){
      if($(this).parents('fieldset').hasClass('done')){
        $(this).parents('fieldset').addClass('edit');
      }
    });
  });

  this.$yes.on('click', function(){
    $('article.referral.no').removeClass('active');
    $('article.referral.yes').addClass('active');
    _this.$referredBy.focus();
    })
    .on('keypress', function(e){
      e.preventDefault();
      if(e.keyCode === 13 || e.keyCode === 32) {
        $(this).trigger('click');
      }
    })
    .on('focus', function(e){
      if($(this).prev().is(':checked')){
        _this.$referredBy.focus();
      }
    });

  this.$no.on('keypress', function(e){
      e.preventDefault();
      if(e.keyCode === 13 || e.keyCode === 32) {
        $(this).trigger('click');
      }
    })
    .on('click', function(){
      _this.$referredBy.val('');
      $('article.referral.yes').removeClass('active');
      $('article.referral.no').addClass('active');
      $(this).trigger('blur');
    });

  this.$submit.on('click', function(e){
    e.preventDefault();
    _this.submit();
  });

  this.$gotit.on('click', function(e){
    e.preventDefault();
    _this.close();
  });

  this.$close.on('click', function(e){
    e.preventDefault();
    _this.close();
  });

  $('body.onboarding').on('keyup', function(e){
    e.preventDefault();
    _this.keyPress(e);
  });

}

LenderOnboarding.prototype.validation = function(){
  this.clearInputStatuses();

  var checkName = $('#name').hasClass('done') && !$('#name').hasClass('edit') ? true : this.checkName();
  var checkCredentials = $('#credentials').hasClass('done') && !$('#credentials').hasClass('edit') ? true : this.checkCredentials();
  var checkReferral = $('#referral').hasClass('done') && !$('#referral').hasClass('edit') ? true : this.checkReferral();
  var checkSend = this.checkSend();

  if(checkName && checkCredentials && checkReferral && checkSend){
    this.$submit.prop('disabled', false);
    return true;
  }else{
    this.$submit.prop('disabled', true);
    return false;
  }
}

LenderOnboarding.prototype.checkName = function(){

  var isFilled = this.$firstname.val() && this.$lastname.val();
  if (isFilled){
    this.username = this.formatUsername(this.$firstname.val()) + ' ' + this.formatUsername(this.$lastname.val());
    var allowedChars = /^[-,'.a-z\d€\u00c0-\u024f\u1e00-\u1eff ]+$/i;
    var isValid =  this.username.length >= 5
      && this.username.length <= 100
      && this.username.includes(' ')
      && allowedChars.test(this.username);

    if (isValid){
      if(!$('#name input').hasClass('callback')){
        $('#name input').addClass('valid');
        $('#name').addClass('checked');
        $('#credentials').removeClass('init').addClass('active');
      }
      Cookies.set('firstname', this.formatUsername(this.$firstname.val()), {expires: 7, secure: 'secure'});
      Cookies.set('lastname', this.formatUsername(this.$lastname.val()), {expires: 7, secure: 'secure'});
      return true;
    }else{
      $('#name input').addClass('error');
    }
  }
  $('#name').removeClass('checked');
  return false;
}

LenderOnboarding.prototype.formatUsername = function(string){
  return string
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, function(firstLetter){ return firstLetter.toUpperCase() })
    .replace(/\s+/g, '-');
}

LenderOnboarding.prototype.checkCredentials = function(){
  var isEmailFilled = this.$email.val();
  var isPasswordFilled = this.$password.val();
  var isFilled = isEmailFilled && isPasswordFilled;
  if (isEmailFilled) {
    var emailIsValid = this.$email[0].checkValidity();
    if(emailIsValid && !this.$email.hasClass('callback')){
      this.$email.addClass('valid');
      Cookies.set('email', this.$email.val(), {expires: 7, secure: 'secure'});
    }else if(!emailIsValid){
      this.$email.addClass('error');
    }
  }
  if (isPasswordFilled) {
    var passwordIsValid = this.$password[0].checkValidity();
    if(passwordIsValid && !this.$password.hasClass('callback')){
      this.$password.addClass('valid');
    }else if(!passwordIsValid){
      this.$password.addClass('error');
    }
  }
  if (isFilled && emailIsValid && passwordIsValid){
    $('#credentials').addClass('checked');
    $('#referral').removeClass('init').addClass('active');
    if ( this.$yes.prev().is(':checked') && !$('article.referral.yes').hasClass('active') ) {
      $('article.referral.yes').addClass('active');
    }
    if(this.referralInfos['partner'] || this.referralInfos['referredBy']){
      $('#send').removeClass('init').addClass('active');
      $('#send').smoothScrollTop();
    }
    return true;
  }else{
    $('#credentials').removeClass('checked');
  }
  return false;
}

LenderOnboarding.prototype.checkReferral = function(){
  var isFilled = (this.$no.prev().is(':checked')) ||
    (this.$yes.prev().is(':checked') && this.$referredBy.val().trim()) ||
    this.referralInfos['partner'] ||
    this.referralInfos['referredBy'];

  if (!!isFilled && !this.$referredBy.hasClass('callback')){
    $('#referral').addClass('checked');
    this.$referredBy.addClass('valid');
    if(this.checkName() && this.checkCredentials()){
      $('#send').removeClass('init').addClass('active');
      $('#send').smoothScrollTop();
    }
    Cookies.set('referredBy', this.$referredBy.val().trim(), {expires: 7, secure: 'secure'});
    return true;
  }else{
    $('#referral').removeClass('checked');
  }
  return false;
}

LenderOnboarding.prototype.checkSend = function(){
  var isFilled = this.isRegulated ?
    this.$agreements.is(':checked') && this.$regulations.is(':checked') :
    this.$agreements.is(':checked');

  if (isFilled){
    return true;
  }
  return false;
}

LenderOnboarding.prototype.isReferrerRegulated = function(){
  var _this = this;
  if (typeof geoip_detect === "function") {
    geoip_detect.get_info().then(
      function(record) {
        var country = record.get('country.iso_code');
        if( (country == 'DE') || (country == 'US') || $('body').hasClass('geoip-country-DE') || $('body').hasClass('geoip-country-US') ){
          $('.regulations.check').removeClass('hidden');
          _this.isRegulated = true;
        }else{
          _this.isRegulated =  false;
        }
      }, function(error){
        _this.isRegulated =  false;
      }
    );
  }else{
    _this.isRegulated =  false;
  }
}
